export async function measureExecutionTime(fn: () => Promise<unknown>|unknown): Promise<number> {
    const startedAt = window.performance.now();
    await fn();
    const endedAt = window.performance.now();
    return endedAt - startedAt;
}